/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/*
 * Extracted from https://github.com/lokesh/color-thief
 * Copyright (c) 2015 Lokesh Dhakar
 * Licensed under the MIT license: http://www.opensource.org/licenses/mit-license.php
 * Modified to reduce scope and clean up code for ES6. Project is dormant so made sense
 * to extract rather than include. disabling es-lint for bitwise operators as this code makes
 * extensive use of them.
 */

/* eslint-disable no-bitwise */

let componentToHex = function (c) {
  let hex = c.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
};

let rgbToHex = function (r, g, b) {
  return `#${componentToHex(r) + componentToHex(g) + componentToHex(b)}`;
};

/*!
 * quantize.js Copyright 2008 Nick Rabinowitz.
 * Licensed under the MIT license: http://www.opensource.org/licenses/mit-license.php
 * @license
 */

// fill out a couple protovis dependencies
/*!
 * Block below copied from Protovis: http://mbostock.github.com/protovis/
 * Copyright 2010 Stanford Visualization Group
 * Licensed under the BSD License: http://www.opensource.org/licenses/bsd-license.php
 * @license
 */
let pv = {
  map(array, f) {
    let o = {};
    return f
      ? array.map(function (d, i) {
          o.index = i;
          return f.call(o, d);
        })
      : array.slice();
  },
  naturalOrder(a, b) {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  },
  sum(array, f) {
    let o = {};
    return array.reduce(
      f
        ? function (p, d, i) {
            o.index = i;
            return p + f.call(o, d);
          }
        : function (p, d) {
            return p + d;
          },
      0,
    );
  },
  max(array, f) {
    return Math.max.apply(null, f ? pv.map(array, f) : array);
  },
};

/**
 * Basic Javascript port of the MMCQ (modified median cut quantization)
 * algorithm from the Leptonica library (http://www.leptonica.com/).
 * Returns a color map you can use to map original pixels to the reduced
 * palette. Still a work in progress.
 *
 * @author Nick Rabinowitz
 * @example

   // array of pixels as [R,G,B] arrays
let myPixels = [[190,197,190], [202,204,200], [207,214,210], [211,214,211], [205,207,207]
  // etc
                ];
let maxColors = 4;

let cmap = MMCQ.quantize(myPixels, maxColors);
let newPalette = cmap.palette();
let newPixels = myPixels.map(function(p) {
    return cmap.map(p);
});

*/
let MMCQ = (function () {
  // private constants
  let sigbits = 5;
  let rshift = 8 - sigbits;
  let maxIterations = 1000;
  let fractByPopulations = 0.75;

  // get reduced-space color index for a pixel
  function getColorIndex(r, g, b) {
    return (r << (2 * sigbits)) + (g << sigbits) + b;
  }

  // Simple priority queue
  function PQueue(comparator) {
    let contents = [];
    let sorted = false;

    function sort() {
      contents.sort(comparator);
      sorted = true;
    }

    return {
      push(o) {
        contents.push(o);
        sorted = false;
      },
      peek(index) {
        if (!sorted) {
          sort();
        }
        if (index === undefined) {
          index = contents.length - 1;
        }
        return contents[index];
      },
      pop() {
        if (!sorted) {
          sort();
        }
        return contents.pop();
      },
      size() {
        return contents.length;
      },
      map(f) {
        return contents.map(f);
      },
      debug() {
        if (!sorted) {
          sort();
        }
        return contents;
      },
    };
  }

  // 3d color space box
  function VBox(r1, r2, g1, g2, b1, b2, histo) {
    let vbox = this;
    vbox.r1 = r1;
    vbox.r2 = r2;
    vbox.g1 = g1;
    vbox.g2 = g2;
    vbox.b1 = b1;
    vbox.b2 = b2;
    vbox.histo = histo;
  }
  VBox.prototype = {
    volume(force) {
      let vbox = this;
      if (!vbox._volume || force) {
        vbox._volume = (vbox.r2 - vbox.r1 + 1) * (vbox.g2 - vbox.g1 + 1) * (vbox.b2 - vbox.b1 + 1);
      }
      return vbox._volume;
    },
    count(force) {
      let vbox = this;
      let histo = vbox.histo;
      if (!vbox._count_set || force) {
        let npix = 0;
        let index;
        let i;
        let j;
        let k;
        for (i = vbox.r1; i <= vbox.r2; i++) {
          for (j = vbox.g1; j <= vbox.g2; j++) {
            for (k = vbox.b1; k <= vbox.b2; k++) {
              index = getColorIndex(i, j, k);
              npix += histo[index] || 0;
            }
          }
        }
        vbox._count = npix;
        vbox._count_set = true;
      }
      return vbox._count;
    },
    copy() {
      let vbox = this;
      return new VBox(vbox.r1, vbox.r2, vbox.g1, vbox.g2, vbox.b1, vbox.b2, vbox.histo);
    },
    avg(force) {
      let vbox = this;
      let histo = vbox.histo;
      if (!vbox._avg || force) {
        let ntot = 0;
        let mult = 1 << (8 - sigbits);
        let rsum = 0;
        let gsum = 0;
        let bsum = 0;
        let hval;
        let i;
        let j;
        let k;
        let histoindex;
        for (i = vbox.r1; i <= vbox.r2; i++) {
          for (j = vbox.g1; j <= vbox.g2; j++) {
            for (k = vbox.b1; k <= vbox.b2; k++) {
              histoindex = getColorIndex(i, j, k);
              hval = histo[histoindex] || 0;
              ntot += hval;
              rsum += hval * (i + 0.5) * mult;
              gsum += hval * (j + 0.5) * mult;
              bsum += hval * (k + 0.5) * mult;
            }
          }
        }
        if (ntot) {
          vbox._avg = [~~(rsum / ntot), ~~(gsum / ntot), ~~(bsum / ntot)];
        } else {
          //                    console.log('empty box');
          vbox._avg = [
            ~~((mult * (vbox.r1 + vbox.r2 + 1)) / 2),
            ~~((mult * (vbox.g1 + vbox.g2 + 1)) / 2),
            ~~((mult * (vbox.b1 + vbox.b2 + 1)) / 2),
          ];
        }
      }
      return vbox._avg;
    },
    contains(pixel) {
      let vbox = this;
      let rval = pixel[0] >> rshift;
      let gval = pixel[1] >> rshift;
      let bval = pixel[2] >> rshift;

      return (
        rval >= vbox.r1 &&
        rval <= vbox.r2 &&
        gval >= vbox.g1 &&
        gval <= vbox.g2 &&
        bval >= vbox.b1 &&
        bval <= vbox.b2
      );
    },
  };

  // Color map
  function CMap() {
    this.vboxes = new PQueue(function (a, b) {
      return pv.naturalOrder(a.vbox.count() * a.vbox.volume(), b.vbox.count() * b.vbox.volume());
    });
  }
  CMap.prototype = {
    push(vbox) {
      this.vboxes.push({
        vbox,
        color: vbox.avg(),
      });
    },
    palette() {
      return this.vboxes.map(function (vb) {
        return vb.color;
      });
    },
    size() {
      return this.vboxes.size();
    },
    map(color) {
      let vboxes = this.vboxes;
      for (let i = 0; i < vboxes.size(); i++) {
        if (vboxes.peek(i).vbox.contains(color)) {
          return vboxes.peek(i).color;
        }
      }
      return this.nearest(color);
    },
    nearest(color) {
      let vboxes = this.vboxes;
      let d1;
      let d2;
      let pColor;
      for (let i = 0; i < vboxes.size(); i++) {
        d2 = Math.sqrt(
          Math.pow(color[0] - vboxes.peek(i).color[0], 2) +
            Math.pow(color[1] - vboxes.peek(i).color[1], 2) +
            Math.pow(color[2] - vboxes.peek(i).color[2], 2),
        );
        if (d2 < d1 || d1 === undefined) {
          d1 = d2;
          pColor = vboxes.peek(i).color;
        }
      }
      return pColor;
    },
    forcebw() {
      // XXX: won't  work yet
      let vboxes = this.vboxes;
      vboxes.sort(function (a, b) {
        return pv.naturalOrder(pv.sum(a.color), pv.sum(b.color));
      });

      // force darkest color to black if everything < 5
      let lowest = vboxes[0].color;
      if (lowest[0] < 5 && lowest[1] < 5 && lowest[2] < 5) {
        vboxes[0].color = [0, 0, 0];
      }

      // force lightest color to white if everything > 251
      let idx = vboxes.length - 1;
      let highest = vboxes[idx].color;
      if (highest[0] > 251 && highest[1] > 251 && highest[2] > 251) {
        vboxes[idx].color = [255, 255, 255];
      }
    },
  };

  // histo (1-d array, giving the number of pixels in
  // each quantized region of color space), or null on error
  function getHisto(pixels) {
    let histosize = 1 << (3 * sigbits);
    let histo = new Array(histosize);
    let index;
    let rval;
    let gval;
    let bval;
    pixels.forEach(function (pixel) {
      rval = pixel[0] >> rshift;
      gval = pixel[1] >> rshift;
      bval = pixel[2] >> rshift;
      index = getColorIndex(rval, gval, bval);
      histo[index] = (histo[index] || 0) + 1;
    });
    return histo;
  }

  function vboxFromPixels(pixels, histo) {
    let rmin = 1000000;
    let rmax = 0;
    let gmin = 1000000;
    let gmax = 0;
    let bmin = 1000000;
    let bmax = 0;
    let rval;
    let gval;
    let bval;
    // find min/max
    pixels.forEach(function (pixel) {
      rval = pixel[0] >> rshift;
      gval = pixel[1] >> rshift;
      bval = pixel[2] >> rshift;
      if (rval < rmin) {
        rmin = rval;
      } else if (rval > rmax) {
        rmax = rval;
      }

      if (gval < gmin) {
        gmin = gval;
      } else if (gval > gmax) {
        gmax = gval;
      }

      if (bval < bmin) {
        bmin = bval;
      } else if (bval > bmax) {
        bmax = bval;
      }
    });
    return new VBox(rmin, rmax, gmin, gmax, bmin, bmax, histo);
  }

  function medianCutApply(histo, vbox) {
    if (!vbox.count()) {
      return;
    }

    let rw = vbox.r2 - vbox.r1 + 1;
    let gw = vbox.g2 - vbox.g1 + 1;
    let bw = vbox.b2 - vbox.b1 + 1;
    let maxw = pv.max([rw, gw, bw]);
    // only one pixel, no split
    if (vbox.count() === 1) {
      return [vbox.copy()];
    }
    /* Find the partial sum arrays along the selected axis. */
    let total = 0;
    let partialsum = [];
    let lookaheadsum = [];
    let i;
    let j;
    let k;
    let sum;
    let index;
    if (maxw === rw) {
      for (i = vbox.r1; i <= vbox.r2; i++) {
        sum = 0;
        for (j = vbox.g1; j <= vbox.g2; j++) {
          for (k = vbox.b1; k <= vbox.b2; k++) {
            index = getColorIndex(i, j, k);
            sum += histo[index] || 0;
          }
        }
        total += sum;
        partialsum[i] = total;
      }
    } else if (maxw === gw) {
      for (i = vbox.g1; i <= vbox.g2; i++) {
        sum = 0;
        for (j = vbox.r1; j <= vbox.r2; j++) {
          for (k = vbox.b1; k <= vbox.b2; k++) {
            index = getColorIndex(j, i, k);
            sum += histo[index] || 0;
          }
        }
        total += sum;
        partialsum[i] = total;
      }
    } else {
      /* maxw === bw */
      for (i = vbox.b1; i <= vbox.b2; i++) {
        sum = 0;
        for (j = vbox.r1; j <= vbox.r2; j++) {
          for (k = vbox.g1; k <= vbox.g2; k++) {
            index = getColorIndex(j, k, i);
            sum += histo[index] || 0;
          }
        }
        total += sum;
        partialsum[i] = total;
      }
    }
    partialsum.forEach(function (d, i) {
      lookaheadsum[i] = total - d;
    });
    function doCut(color) {
      let dim1 = `${color}1`;
      let dim2 = `${color}2`;
      let left;
      let right;
      let vbox1;
      let vbox2;
      let d2;
      let count2 = 0;
      for (i = vbox[dim1]; i <= vbox[dim2]; i++) {
        if (partialsum[i] > total / 2) {
          vbox1 = vbox.copy();
          vbox2 = vbox.copy();
          left = i - vbox[dim1];
          right = vbox[dim2] - i;
          if (left <= right) {
            d2 = Math.min(vbox[dim2] - 1, ~~(i + right / 2));
          } else {
            d2 = Math.max(vbox[dim1], ~~(i - 1 - left / 2));
          }
          // avoid 0-count boxes
          while (!partialsum[d2]) {
            d2++;
          }
          count2 = lookaheadsum[d2];
          while (!count2 && partialsum[d2 - 1]) {
            count2 = lookaheadsum[--d2];
          }
          // set dimensions
          vbox1[dim2] = d2;
          vbox2[dim1] = vbox1[dim2] + 1;
          //                    console.log('vbox counts:', vbox.count(), vbox1.count(), vbox2.count());
          return [vbox1, vbox2];
        }
      }
    }
    // determine the cut planes
    if (maxw === rw) {
      return doCut('r');
    } else if (maxw === gw) {
      return doCut('g');
    } else {
      return doCut('b');
    }
  }

  function quantize(pixels, maxcolors) {
    // short-circuit
    if (!pixels.length || maxcolors < 2 || maxcolors > 256) {
      //            console.log('wrong number of maxcolors');
      return false;
    }

    // XXX: check color content and convert to grayscale if insufficient

    let histo = getHisto(pixels);

    // get the beginning vbox from the colors
    let vbox = vboxFromPixels(pixels, histo);
    let pq = new PQueue(function (a, b) {
      return pv.naturalOrder(a.count(), b.count());
    });
    pq.push(vbox);

    // inner function to do the iteration
    function iter(lh, target) {
      let ncolors = 1;
      let niters = 0;
      let vbox;
      while (niters < maxIterations) {
        vbox = lh.pop();
        if (!vbox.count()) {
          /* just put it back */
          lh.push(vbox);
          niters++;
        } else {
          let vboxes = medianCutApply(histo, vbox);
          let vbox1 = vboxes[0];
          let vbox2 = vboxes[1];

          if (!vbox1) {
            return;
          }
          lh.push(vbox1);
          if (vbox2) {
            /* vbox2 can be null */
            lh.push(vbox2);
            ncolors++;
          }
          if (ncolors >= target) {
            return;
          }
          if (niters++ > maxIterations) {
            return;
          }
        }
      }
    }

    // first set of colors, sorted by population
    iter(pq, fractByPopulations * maxcolors);

    // Re-sort by the product of pixel occupancy times the size in color space.
    let pq2 = new PQueue(function (a, b) {
      return pv.naturalOrder(a.count() * a.volume(), b.count() * b.volume());
    });
    while (pq.size()) {
      pq2.push(pq.pop());
    }

    // next set - generate the median cuts using the (npix * vol) sorting.
    iter(pq2, maxcolors - pq2.size());

    // calculate the actual colors
    let cmap = new CMap();
    while (pq2.size()) {
      cmap.push(pq2.pop());
    }

    return cmap;
  }

  return { quantize };
})();
/*
  CanvasImage Class
  Class that wraps the html image element and canvas.
  It also simplifies some of the canvas context manipulation
  with a set of helper functions.
  */

let CanvasImage = function (image) {
  this.canvas = document.createElement('canvas');
  this.context = this.canvas.getContext('2d');

  document.body.appendChild(this.canvas);

  this.width = this.canvas.width = image.width;
  this.height = this.canvas.height = image.height;

  this.context.drawImage(image, 0, 0, this.width, this.height);
};

CanvasImage.prototype.getPixelCount = function () {
  return this.width * this.height;
};

CanvasImage.prototype.getImageData = function () {
  return this.context.getImageData(0, 0, this.width, this.height);
};

CanvasImage.prototype.removeCanvas = function () {
  this.canvas.parentNode.removeChild(this.canvas);
};

/*
 * getPalette(sourceImage[, colorCount])
 * returns array[ {r: num, g: num, b: num}, {r: num, g: num, b: num}, ...]
 *
 * Use the median cut algorithm provided by quantize.js to cluster similar colors.
 *
 * colorCount determines the size of the palette; the number of colors returned. If not set, it
 * defaults to 10.
 *
 */
export function extractColors(sourceImage, colorCount) {
  if (typeof colorCount === 'undefined' || colorCount < 2 || colorCount > 256) {
    colorCount = 10;
  }

  let quality = 1;

  // Create custom CanvasImage object
  let image = new CanvasImage(sourceImage);
  let imageData = image.getImageData();
  let pixels = imageData.data;
  let pixelCount = image.getPixelCount();

  // Store the RGB values in an array format suitable for quantize function
  let pixelArray = [];
  for (let i = 0, offset, r, g, b, a; i < pixelCount; i += quality) {
    offset = i * 4;
    r = pixels[offset + 0];
    g = pixels[offset + 1];
    b = pixels[offset + 2];
    a = pixels[offset + 3];
    // If pixel is mostly opaque and not white
    if (a >= 125) {
      if (!(r > 180 && g > 180 && b > 180)) {
        pixelArray.push([r, g, b]);
      }
    }
  }

  // Send array to quantize function which clusters values
  // using median cut algorithm
  let cmap = MMCQ.quantize(pixelArray, colorCount);
  let palette = cmap ? cmap.palette() : null;

  // Clean up
  image.removeCanvas();

  return palette.map((color) => rgbToHex(...color).toUpperCase());
}

export function extractColorFromClickEvent(event, image) {
  let canvas = document.createElement('canvas');
  canvas.width = image.width;
  canvas.height = image.height;
  let ctx = canvas.getContext('2d');

  ctx.drawImage(image, 0, 0, image.width, image.height);
  let color = ctx.getImageData(event.offsetX, event.offsetY, 1, 1).data;

  return rgbToHex(...color).toUpperCase();
}

/* eslint-enable no-bitwise */
